import React, { useState } from "react";
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import {
  TableCell,
  TableRow,
  IconButton,
  Tooltip
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import VisibilityIcon from "@material-ui/icons/Visibility";
import BarChartIcon from "@material-ui/icons/BarChart";
import Table from "../../../components/Table";
import messages from "../../../assets/locale/messages";
import EmptyState from "../../../components/EmptyState";
import Pagination from "../../../components/Pagination";
import { deleteAction } from "../../../store/ActionsBtn/actions";
import { getSurveysRequest } from "../../../store/Surveys/actions";
import { ROUTE_PATHS } from "../../../utils/PathsNames";

const SurveysList = ({ list, lang }) => {
  const dispatch = useDispatch();
  let history = useHistory();
  const isLoading = useSelector((state) => state.loader);
  const meta = useSelector((state) => state.surveys.meta);
  const title = useSelector((state) => state.surveys.title);

  const [page, setPage] = useState(1);
  const perPage = 10;

  const handlePagination = (event, page) => {
    setPage(page);
    dispatch(
      getSurveysRequest({
        title: title,
        page: page,
        items: perPage
      })
    );
  };

  const handleDelete = (id) => {
    dispatch(deleteAction(id));
  };

  const handleView = (id) => {
    history.push(`${ROUTE_PATHS["surveysDetails"]}/${id}`);
  };

  const handleStatistics = (id) => {
    history.push(`${ROUTE_PATHS["surveysStatistics"]}/${id}`);
  };

  const handleEdit = (id) => {
    history.push(`${ROUTE_PATHS["editSurvey"]}/${id}`);
  };

  const {
    surveys: { surveyTitle, bookRelated, statitics },
    shared: { viewLabel, editLabel, deleteLabel }
  } = messages[lang];
  return (
    <>
      <Table
        headlines={[surveyTitle, bookRelated]}
        hasActions={true}
        rows={list.map((row) => (
          <TableRow className="table__row" key={row.id}>
            <TableCell className="table__cell" align="left">
              {row.title}
            </TableCell>
            <TableCell className="table__cell" align="left">
              {row.book_title}
            </TableCell>

            <TableCell
              className="table__cell table__actions"
              align="right"
            >
              <Tooltip title={viewLabel}>
                <span>
                  <IconButton
                    onClick={() => handleView(row.id)}
                    aria-label="view"
                  >
                    <VisibilityIcon
                      className="table__view"
                      fontSize="medium"
                    />
                  </IconButton>
                </span>
              </Tooltip>

              <Tooltip title={statitics}>
                <span>
                  <IconButton
                    onClick={() => handleStatistics(row.id)}
                    aria-label="statitics"
                  >
                    <BarChartIcon
                      className="table__statitics"
                      fontSize="medium"
                    />
                  </IconButton>
                </span>
              </Tooltip>

              <Tooltip title={editLabel}>
                <span>
                  <IconButton
                    onClick={() => handleEdit(row.id)}
                    aria-label="edit"
                  >
                    <EditIcon
                      className="table__edit"
                      fontSize="medium"
                    />
                  </IconButton>
                </span>
              </Tooltip>

              <Tooltip title={deleteLabel}>
                <span>
                  <IconButton
                    onClick={() => handleDelete(row.id)}
                    aria-label="delete"
                    className="text-gray"
                  >
                    <DeleteIcon
                      className={`table__delete`}
                      fontSize="medium"
                    />
                  </IconButton>
                </span>
              </Tooltip>
            </TableCell>
          </TableRow>
        ))}
      />
      {!isLoading && !list.length && <EmptyState />}
      {meta.pages > 1 && (
        <Pagination
          count={meta.pages}
          page={meta.currentPage || page}
          handleChange={handlePagination}
        />
      )}
    </>
  );
};

SurveysList.propTypes = {
  lang: PropTypes.string,
  list: PropTypes.arrayOf(PropTypes.object)
};

export default SurveysList;
